import { z } from 'zod';
/** What an app asks for on /oauth/authorize (OAuth 2.1 with PKCE, doc 37). */
export const AuthorizeRequestSchema = z.object({
    response_type: z.literal('code', { error: 'response_type must be code' }),
    client_id: z.string().min(1).max(64),
    redirect_uri: z.string().min(1).max(500),
    code_challenge: z.string().regex(/^[A-Za-z0-9_-]{43}$/, 'code_challenge must be an S256 PKCE challenge'),
    code_challenge_method: z.literal('S256', { error: 'Only PKCE with S256 is supported' }),
    state: z.string().max(1000).optional(),
    scope: z.string().max(200).optional(),
    resource: z.string().max(500).optional(),
});
/** The consent page's view of a valid request. */
export const AuthorizeInfoResponseSchema = z.object({ clientName: z.string(), redirectHost: z.string() });
export const AuthorizeDecisionRequestSchema = AuthorizeRequestSchema.extend({ allow: z.boolean() });
/** Where the browser goes next: back to the app, with a code or with access_denied. */
export const AuthorizeDecisionResponseSchema = z.object({ redirectTo: z.string() });
/** An app the user connected (Claude desktop, web, phone …). */
export const ConnectedAppSchema = z.object({
    id: z.string(),
    name: z.string(),
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
});
export const ConnectedAppsResponseSchema = z.object({ apps: z.array(ConnectedAppSchema) });
//# sourceMappingURL=oauth.js.map